export enum MediaManagerMediaType {
  IMAGE = 'IMAGE',
  ALL_MEDIA = 'ALL_MEDIA',
  VIDEO = 'VIDEO',
  AUDIO = 'MUSIC',
}
export interface EditorMediaPanelOptions {
  mediaType?: MediaManagerMediaType;
  isMultiSelect?: boolean;
}
interface BMMediaPanelOptions {
  multiSelect?: boolean;
  onSuccess?: (data: $TSFixMe) => void;
}

interface BMMediaSDK {
  invoke(
    name: string,
    mediaType: MediaManagerMediaType,
    appDefId: string,
    options: BMMediaPanelOptions
  ): void;
  registeredMethods?: {
    ['mediaManager.open']?: any;
  };
}

interface EditorMediaSDK {
  editor: {
    openMediaPanel: (token?: string, options?: EditorMediaPanelOptions) => Promise<any>;
  };
}

declare global {
  interface Window {
    ModuleRegistry?: BMMediaSDK;
    editorSDK?: EditorMediaSDK;
  }
}

export const createMediaMangerOpener = (mediaManagerInstance: BMMediaSDK | EditorMediaSDK) => {
  return async ({
    mediaType,
    isMultiSelect,
    appDefId,
    onSuccess,
  }: {
    mediaType: MediaManagerMediaType;
    isMultiSelect?: boolean;
    appDefId?: string;
    onSuccess: (data: $TSFixMe) => void;
  }) => {
    if ('editor' in mediaManagerInstance) {
      await mediaManagerInstance.editor
        .openMediaPanel('', {
          mediaType,
          isMultiSelect,
        })
        .then(onSuccess);
    } else {
      mediaManagerInstance.invoke('mediaManager.open', mediaType, appDefId || '', {
        multiSelect: isMultiSelect,
        onSuccess: data => onSuccess(data.items),
      });
    }
  };
};
